import React, { useState } from 'react';

export default function MazePuzzle({ data, onSolved }) {
  const { grid, prompt } = data;

  // Find start position
  const findCell = (value) => {
    for (let r = 0; r < grid.length; r++) {
      for (let c = 0; c < grid[r].length; c++) {
        if (grid[r][c] === value) return { r, c };
      }
    }
    return { r: 0, c: 0 };
  };

  const start = findCell(2);
  const [pos, setPos] = useState(start);
  const [visited, setVisited] = useState([`${start.r}-${start.c}`]);

  const isAdjacent = (r, c) => {
    const dr = Math.abs(r - pos.r);
    const dc = Math.abs(c - pos.c);
    return (dr === 1 && dc === 0) || (dr === 0 && dc === 1);
  };

  const handleCellClick = (r, c) => {
    const cellVal = grid[r][c];
    if (cellVal === 1) return; // wall
    if (!isAdjacent(r, c)) return;

    const key = `${r}-${c}`;
    setPos({ r, c });
    setVisited((prev) => [...prev, key]);

    if (cellVal === 3) {
      setTimeout(onSolved, 400);
    }
  };

  const getCellClass = (r, c) => {
    const val = grid[r][c];
    const key = `${r}-${c}`;
    const isVisited = visited.includes(key);
    const isCurrent = pos.r === r && pos.c === c;

    if (val === 1) return 'maze-wall';
    if (isCurrent) return 'maze-current';
    if (val === 3) return 'maze-end';
    if (val === 2) return 'maze-start';
    if (isVisited) return 'maze-visited';
    return 'maze-path';
  };

  return (
    <div className="puzzle-maze">
      <p className="puzzle-prompt">{prompt}</p>
      <p className="puzzle-hint">Click adjacent cells to move through the jungle!</p>
      <div className="maze-grid" style={{ gridTemplateColumns: `repeat(${grid[0].length}, 1fr)` }}>
        {grid.map((row, r) =>
          row.map((cell, c) => (
            <button
              key={`${r}-${c}`}
              className={`maze-cell ${getCellClass(r, c)}`}
              onClick={() => handleCellClick(r, c)}
            >
              {pos.r === r && pos.c === c
                ? '🥾'
                : cell === 2
                ? '🚶'
                : cell === 3
                ? '🏊'
                : cell === 1
                ? ['🎋', '🌿', '🎍', '🌴'][((r * 7) + c) % 4]
                : ''}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
